import { ReactNode } from 'react';
import presseLaunchImage from '../assets/presse-launch.jpeg';
import presseEfre2Image from '../assets/presse-efre2.jpeg';

type TimelineImage = {
  src: string;
  alt: string;
  loading?: 'eager' | 'lazy';
};

type TimelineEntry = {
  id: string;
  date: string;
  dateISO: string;
  title: string;
  lang?: string;
  body: ReactNode;
  images?: TimelineImage[];
};

// Ordered newest-first. Append new entries at the top.
const timelineEntries: TimelineEntry[] = [
  {
    id: 'launch-2026-03',
    date: '27. März 2026',
    dateISO: '2026-03-27',
    title: 'Offizieller Start für Smart Transform 5.0',
    images: [
      {
        src: presseLaunchImage,
        alt: 'Übergabe des Zuwendungsbescheids Smart Transform 5.0 im InnovationSPIN Lemgo mit Bezirksregierung Detmold und Projektpartnern',
        loading: 'eager',
      },
      {
        src: presseEfre2Image,
        alt: 'Smart Transform 5.0 Projektpartner und Gäste beim Launch-Event im InnovationSPIN Lemgo',
        loading: 'lazy',
      },
    ],
    body: (
      <>
        <p>
          Am Freitag war es soweit: Im InnovationSPIN in Lemgo wurde uns als Konsortialpartnern
          durch die Regierungspräsidentin Anna Katharina Boelling offiziell der Förderbescheid der
          Bezirksregierung Detmold für unser Projekt Smart Transform 5.0 übergeben. Ermöglicht wird
          das Projekt durch die Förderung des Ministerium für Wirtschaft, Industrie, Klimaschutz
          und Energie des Landes NRW und die Europäische Union: Ein wichtiger Meilenstein und
          gleichzeitig der Startschuss für die nächsten drei Jahre intensiver Zusammenarbeit.
        </p>
        <p>
          Mit Smart Transform 5.0 wollen wir die regionale Wirtschaft aktiv bei der Transformation
          hin zu einer nachhaltigen, resilienten und menschenzentrierten Industrie unterstützen. Im
          Mittelpunkt stehen dabei die enge Verzahnung von Wissenschaft und Praxis sowie die Frage,
          wie Technologien wie KI und IoT sinnvoll im Arbeitsalltag eingesetzt werden können.
        </p>
        <p>
          Gemeinsam mit starken Partnern bringen wir als IMA Innovationsmanufaktur Gütersloh GmbH
          (Projektleitung), zusammen mit der Hochschule Bielefeld, dem KogniHome -
          Technikunterstütztes Wohnen für Menschen e. V. und der MINTkitchen, Innovation in die
          Region und machen Industrie 5.0 konkret erlebbar.
        </p>
        <p>
          💡 Unser Ziel: Unternehmen, insbesondere KMU, befähigen, ihre Wettbewerbsfähigkeit
          nachhaltig zu stärken und neue Wege der Wertschöpfung zu erschließen.
        </p>
        <p>
          Wir freuen uns auf die kommenden Schritte, spannende Kooperationen und viele Impulse aus
          der Praxis!
        </p>
      </>
    ),
  },
];

function Presse() {
  return (
    <div className="home-container">
      <section className="home-section home-section--presse" aria-label="Presse">
        <div className="section-inner">
          <ol className="presse-timeline" aria-label="Presse-Zeitstrahl">
            {timelineEntries.map((entry) => (
              <li key={entry.id} className="presse-timeline-item">
                <div className="presse-timeline-marker" aria-hidden="true" />
                <article className="presse-timeline-content" lang={entry.lang}>
                  <time className="presse-timeline-date" dateTime={entry.dateISO}>
                    {entry.date}
                  </time>
                  <h2 className="presse-timeline-title">{entry.title}</h2>
                  <div className="presse-timeline-body">{entry.body}</div>
                  {entry.images && entry.images.length > 0 && (
                    <div
                      className={`presse-timeline-media presse-timeline-media--${entry.images.length === 1 ? 'single' : 'grid'}`}
                    >
                      {entry.images.map((image, idx) => (
                        <img
                          key={idx}
                          src={image.src}
                          alt={image.alt}
                          loading={image.loading ?? 'lazy'}
                        />
                      ))}
                    </div>
                  )}
                </article>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
}

export default Presse;
